"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var indicativeNumberStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        container: {
            marginLeft: 5,
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 15,
            height: 15,
            borderRadius: '100%',
            background: palette.primary.main,
            position: 'relative',
        },
        labelText: { color: palette.common.white, fontSize: 9, fontWeight: typography.fontWeightBold, textAlign: 'center' },
    });
}, { name: 'GqlSummary_Indicative_Number' });
exports.default = indicativeNumberStyles;
